import { forwardRef, HTMLAttributes, ReactNode, Ref } from 'react';
import { Container } from '@optimus-web/core';

export interface ContentContainerProps extends HTMLAttributes<HTMLElement> {
    children: ReactNode;
    condensed?: boolean;
    maxWidth?: '640px' | '960px' | 'none';
    align?: 'left' | 'center' | 'right';
    ref?: Ref<HTMLDivElement>;
}

export const ContentContainer = forwardRef<HTMLDivElement, ContentContainerProps>(
    ({ children, condensed, maxWidth, align = 'center', ...other }: ContentContainerProps, ref) => (
        <Container
            maxWidth={maxWidth}
            padding={condensed ? '100' : ['300', '200']}
            largePhoneMax={{ padding: '0' }}
            desktopUp={{
                padding: condensed ? '200' : ['400', '300'],
            }}
            align={align}
            position="relative"
            ref={ref}
            {...other}
        >
            {children}
        </Container>
    )
);

export const SmallContentContainer = (props: Exclude<ContentContainerProps, 'maxWidth'>) => (
    <ContentContainer maxWidth="640px" {...props} />
);

export const LargeContentContainer = (props: Exclude<ContentContainerProps, 'maxWidth'>) => (
    <ContentContainer maxWidth="960px" {...props} />
);
